/*
 * @title: 
 * @Author: wangshuai
 * @Date: 2024-09-10 13:17:46
 * @FilePath: \飞行-运控\src\api\model\navigation.js
 * @Description: 通航机场相关信息
 * 
 */

import config from "@/config";
import http from "@/utils/request";

export default {
	webAriport: {
		url: `${config.HNYJ_URL}/th/v1/thAirport/webAriport`,
		name: "web-查询机场",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	getById: {
		url: `${config.HNYJ_URL}/th/v1/thAirport/byId`,
		name: "通过ID查询单条数据",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
};
